import React from 'react';
import { SvgIconProps } from '@mui/material';

export const PaperFilledIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.10938 3.10938C3.10938 1.8425 4.13938 0.8125 5.40625 0.8125H11.1484V5.40625C11.1484 6.04148 11.6616 6.55469 12.2969 6.55469H16.8906V16.8906C16.8906 18.1575 15.8606 19.1875 14.5938 19.1875H5.40625C4.13938 19.1875 3.10938 18.1575 3.10938 16.8906V3.10938ZM16.8906 5.40625H12.2969V0.8125L16.8906 5.40625Z"
            fill="currentColor"
        />
    </svg>
);

export default PaperFilledIcon;
